/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Toast_GeneratedInputs */

const en_cover_letters_toast_generated = /** @type {(inputs: Cover_Letters_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cover letter generated`)
};

const de_cover_letters_toast_generated = /** @type {(inputs: Cover_Letters_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben generiert`)
};

const fr_cover_letters_toast_generated = /** @type {(inputs: Cover_Letters_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettre de motivation générée`)
};

const es_cover_letters_toast_generated = /** @type {(inputs: Cover_Letters_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carta de presentación generada`)
};

const it_cover_letters_toast_generated = /** @type {(inputs: Cover_Letters_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettera di presentazione generata`)
};

const nl_cover_letters_toast_generated = /** @type {(inputs: Cover_Letters_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivatiebrief gegenereerd`)
};

const pl_cover_letters_toast_generated = /** @type {(inputs: Cover_Letters_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List motywacyjny wygenerowany`)
};

const fi_cover_letters_toast_generated = /** @type {(inputs: Cover_Letters_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatekirje luotu`)
};

const da_cover_letters_toast_generated = /** @type {(inputs: Cover_Letters_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningsbrev genereret`)
};

const sv_cover_letters_toast_generated = /** @type {(inputs: Cover_Letters_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personligt brev genererat`)
};

/**
* | output |
* | --- |
* | "Cover letter generated" |
*
* @param {Cover_Letters_Toast_GeneratedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_toast_generated = /** @type {((inputs?: Cover_Letters_Toast_GeneratedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Toast_GeneratedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_toast_generated(inputs)
	if (locale === "fr") return fr_cover_letters_toast_generated(inputs)
	if (locale === "es") return es_cover_letters_toast_generated(inputs)
	if (locale === "it") return it_cover_letters_toast_generated(inputs)
	if (locale === "nl") return nl_cover_letters_toast_generated(inputs)
	if (locale === "pl") return pl_cover_letters_toast_generated(inputs)
	if (locale === "fi") return fi_cover_letters_toast_generated(inputs)
	if (locale === "da") return da_cover_letters_toast_generated(inputs)
	if (locale === "sv") return sv_cover_letters_toast_generated(inputs)
	return en_cover_letters_toast_generated(inputs)
});